module.exports = __webpack_public_path__ + "static/img/product_dianhan.6281ceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_dianhan.jpg
// module id = TTHM
// module chunks = 0